export enum LimitType {
	DAILY_LIMIT = "daily-limit",
	WEEKLY_LIMIT = "weekly-limit",
	MONTHLY_LIMIT = "monthly-limit",
}
